module.exports = __webpack_public_path__ + "img/instagram-pc-example@2x.c6721b4d.png";